import React from 'react';

import { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import { Editor } from '@tinymce/tinymce-react';

import DatePicker from 'react-datepicker';

import FAQStore from '../../../stores/FAQStore';

const MediaUsageGoalEditPage = ({ users }) => {
    const navigate = useNavigate();

    const store = FAQStore((state) => state);

    const editorRef = useRef(null);

    //useParams returns strings, so we convert it to a number here
    const faqItemId = Number(useParams().faqItemId);

    useEffect(() => {
        store.load(faqItemId);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.faqItem) {
        return <div>Loading ...</div>;
    }

    const getFormInputComponent = function (faqItem, attributeName) {
        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={faqItem.id}
                        />
                    </FormGroup>
                );

            case 'title':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Label<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={faqItem.title}
                            onChange={(e) => {
                                store.updateAttribute('title', e.target.value);
                            }}
                        />
                    </FormGroup>
                );

            case 'position':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Position<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={faqItem.position}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'position',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'htmlContent':
                return (
                    <Editor
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        value={faqItem.htmlContent}
                        init={{
                            height: 500,
                            menubar: false,
                            plugins: ['code', 'media'],
                            toolbar:
                                'undo redo | formatselect | ' +
                                'bold italic backcolor | alignleft aligncenter ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'removeformat | help | code | media',
                            content_style:
                                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                        }}
                        onEditorChange={(content) => {
                            store.updateAttribute('htmlContent', content);
                        }}
                    />
                );

			case 'dateCreation':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel style={{ marginRight: '8px' }}>
                            Date of creation
                        </FormLabel>
                        <DatePicker
                            showIcon
                            locale="de"
                            selected={faqItem.dateCreation}
                            onChange={(date) => {
                                store.updateAttribute(
                                    'dateCreation',
                                    date.getTime(),
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'dateUpDate':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel style={{ marginRight: '8px' }}>
                            Date of update
                        </FormLabel>
                        <DatePicker
                            showIcon
                            locale="de"
                            selected={faqItem.dateUpDate}
                            onChange={(date) => {
                                store.updateAttribute(
                                    'dateUpDate',
                                    date.getTime(),
                                );
                            }}
                        />
                    </FormGroup>
                );

			case 'video':
				return <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        
						<div style={{marginLeft: "20px", marginTop: "10px"}}>

							<FormLabel>Video URL</FormLabel>
	                        <FormControl
	                            type="url"
	                            placeholder="Enter Video URL here..."
	                            value={ faqItem.video }
	                            onChange={(e) => {
									store.updateAttribute("video", e.target.value);
	                            }}
	                        />

						</div>
						
						<iframe
							style={{marginLeft: "20px", marginTop: "10px"}}
		                    width="315"
		                    src={faqItem.video}
		                    title="YouTube video player"
		                    frameborder="0"
		                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
		                    referrerpolicy="strict-origin-when-cross-origin"
		                    allowfullscreen
		                ></iframe>
                    </FormGroup>;

            default:
                return null;
        }
    };

    var formInputElements = [];

    formInputElements.push(getFormInputComponent(store.faqItem, 'id'));
    formInputElements.push(getFormInputComponent(store.faqItem, 'title'));
    formInputElements.push(getFormInputComponent(store.faqItem, 'position'));	
    formInputElements.push(getFormInputComponent(store.faqItem, 'htmlContent'));
	formInputElements.push(getFormInputComponent(store.faqItem, 'dateCreation'));
	formInputElements.push(getFormInputComponent(store.faqItem, 'dateUpDate'));
	formInputElements.push(getFormInputComponent(store.faqItem, 'video'));

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/faq/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>FAQ Item Edit Page</div>
                    <br />
                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                navigate('/faq');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.update(
                                    store.faqItem,
                                    () => {
                                        alert('Your edits were saved');
                                        navigate('/faq');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.faqItem.id,
                                    () => {
                                        alert('The faqItem was deleted');
                                        navigate('/faq');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default MediaUsageGoalEditPage;
